import React, { useState, useEffect } from "react";import {
    MEMBER_WITH_RAF,MEMBER_WITH_GAP, PPG_SUMMARY
  } from "../../assets/constants/string.constants";
import ACAMemberWithRaf from './ACAMemberWithRaf';
import ACAMemberWithGap from './ACAMemberWithGap';
import PGPDetailsACA from './ACAPGP.page';
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../components/Tab/TabPanel";
import { connect } from 'react-redux';

const ACAPPGSummary = (props) => {
    const [value, setValue] = useState(PPG_SUMMARY);

    function a11yProps(index) {
        return {
          id: `wrapped-tab-${index}`,
          "aria-controls": `wrapped-tabpanel-${index}`,
        };
      }

      const handleChange = (event, newValue) => {
        setValue(newValue);
      };

    return (
        <div className="container level-summary">
        <AppBar position="static" color="default">
        <Tabs
          variant="fullWidth"
          textColor="primary"
          indicatorColor="primary"
          value={value}
          onChange={handleChange}
          centered
        >
          <Tab
            value={PPG_SUMMARY}
            label="PPG SUMMARY"
            {...a11yProps(PPG_SUMMARY)}
          />  
          {/* <Tab
            value={MEMBER_WITH_RAF}
            label="Member With Raf"
            {...a11yProps(MEMBER_WITH_RAF)}
          /> */}
          <Tab
            value={MEMBER_WITH_GAP}
            label="Member With Gap"
            {...a11yProps(MEMBER_WITH_GAP)}
          />      
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={PPG_SUMMARY}>
        <PGPDetailsACA></PGPDetailsACA>
          <div className="col-lg-12 pr-0 pl-0 mt-5"></div>
          <br/>
          <br/>
          <br/> 
      </TabPanel>
      {/* <TabPanel value={value} index={MEMBER_WITH_RAF}>
        <ACAMemberWithRaf></ACAMemberWithRaf>
          <div className="col-lg-12 pr-0 pl-0 mt-5"></div>
          <br/>
          <br/>
          <br/> 
      </TabPanel> */}
      <TabPanel value={value} index={MEMBER_WITH_GAP}>
        <ACAMemberWithGap></ACAMemberWithGap>
          <div className="col-lg-12 pr-0 pl-0 mt-5"></div>
          <br/>
          <br/>
          <br/> 
      </TabPanel>
      
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        moduleSelect: state.moduleFilter.moduleSelect,
        viewBySelect: state.moduleFilter.viewBySelect,
        modelSelect: state.moduleFilter.modelSelect,
        metalTierSelect: state.moduleFilter.metalTierSelect,
        planSelect: state.moduleFilter.planSelect,
        yearSelect: state.moduleFilter.yearSelect,
    };
  }
export default connect(mapStateToProps)(ACAPPGSummary);
